import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { axiosInstance } from '../../../axios/axiosInstance';
import { userData } from '../../../recoil/atoms/userDataAtom';
import { MeMessagesType } from '../../model/interfaces/MeMessagesType';

export const meMessagesKey = ['ME_MESSAGES'];

interface MeMessagesResponse {
  data: MeMessagesType;
}

export const useGetMeMessages = () => {
  const user = useRecoilValue(userData);

  return useQuery<MeMessagesResponse>({
    queryKey: [...meMessagesKey],
    queryFn: async () => {
      const { data } = await axiosInstance.get('/api/users/me/messages');
      return data;
    },
    enabled: !!user?.data?.id,
    retry: 2,
    retryDelay: 1000
  });
};
